<script setup lang="ts">
import { computed } from "vue"
import { useRoute } from "vue-router"

import AppShell from "./components/AppShell.vue"
import AdminShell from "./components/AdminShell.vue"

const route = useRoute()
const isPublic = computed(() => Boolean(route.meta.public))
const isAdmin = computed(() => Boolean(route.meta.admin))
</script>

<template>
  <RouterView v-if="isPublic" />
  <AdminShell v-else-if="isAdmin" />
  <AppShell v-else />
</template>
